import { render, staticRenderFns } from "./recoverpw-sample.vue?vue&type=template&id=04ba6470&"
import script from "./recoverpw-sample.vue?vue&type=script&lang=js&"
export * from "./recoverpw-sample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports